module.exports = __webpack_public_path__ + "static/ConsultFGC_Logo-1714096432cc4fd9a8653a11b0a67248.png";